/** Визуално разграничение Период 1 / 2 / 3 — pill полета. */
export type PeriodTone = 1 | 2 | 3;

export const period1Color = {
    accent: "#14325c",
    softBg: "rgba(20, 50, 92, 0.08)",
    border: "rgba(20, 50, 92, 0.35)",
    label: "#14325c",
} as const;

export const period2Color = {
    accent: "#b45309",
    softBg: "rgba(180, 83, 9, 0.08)",
    border: "rgba(180, 83, 9, 0.35)",
    label: "#b45309",
} as const;

export const period3Color = {
    accent: "#7c3aed",
    softBg: "rgba(124, 58, 237, 0.08)",
    border: "rgba(124, 58, 237, 0.35)",
    label: "#7c3aed",
} as const;

export function periodToneColor(period: PeriodTone) {
    if (period === 2) {
        return period2Color;
    }

    if (period === 3) {
        return period3Color;
    }

    return period1Color;
}

export function periodFieldSx(period: PeriodTone = 1) {
    const tone = periodToneColor(period);

    return {
        "& .MuiOutlinedInput-root": {
            borderRadius: 999,
            bgcolor: tone.softBg,
            "& fieldset": { borderColor: tone.border },
            "&:hover fieldset": { borderColor: tone.accent },
            "&.Mui-focused fieldset": { borderColor: tone.accent },
        },
        "& .MuiInputLabel-root": { color: tone.label },
        "& .MuiInputLabel-root.Mui-focused": { color: tone.accent },
        "& .MuiSelect-icon, & .MuiIconButton-root": { color: tone.accent },
    } as const;
}
